import _ from 'lodash';
import React from 'react';
import {connect} from 'dva';
import {
  Button,
  Checkbox,
  DatePicker,
  Icon,
  InputNumber,
  Modal,
  Radio,
  Select,
  Switch,
  Table,
  TimePicker,
  Upload
} from 'antd';
import {formatTimeStampToDate, getTimeLists, strToSecond} from '../../utils/common.js';
import MoreMeetingIndex from './MoreMeetingIndex';
import {FormattedMessage} from 'react-intl';
import moment from 'moment';
import {
  ATTEND_MODAL,
  CLIENT_ID,
  ENGLISH,
  HOLDER_MODAL,
  MEETING_AUDIT,
  MEETING_STATUS,
  MEETING_TYPES,
  ROOM_NEED_AUDIT,
  SEMICOLON,
  SVC_STATE,
  WEEKDAY
} from '../../utils/constants.js';
import {Base64} from 'js-base64';
import {getUrlParam} from '../../utils/common';
import {Meeting, RES_STATUS, ROLES_KEY, TIME_FORMAT} from '../../utils/constants';
import UserSelect from './UserSelect';
import IconTip from '../IconTip';

const Option = Select.Option;
const RadioGroup = Radio.Group;
const CheckboxGroup = Checkbox.Group;

//会议预订页面
class MeetingDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      crossDay: 0,
      tempMeeting: {},
      tempReType: '',
      showPriceModal: false,
      priceInfo: null,
      meetingId: 0,
      meetingName: '',
      beginTime: null,
      endTime: null,
      attends: [],
      holder: [],
      position: {},
      isLoop: false, //是否循环会议
      loopType: 'day', //循环类型day, week, month, year
      defaultStartTime: 480, //循环会议默认开始时间
      defaultEndTime: 495, //循环会议默认开始时间
      loopInterval: 15, //循环会议持续时间
      loopStartLists: [],
      loopEndLists: [],
      openVideo: 1, //开启直录播
      needToSign: 0,
      signTime: 15,
      meetingType: MEETING_TYPES.local,
      tempUser: [{}, {}], //临时记录选择的用户，0：参会人，1：主持人
      externalForm: {userName: '', email: '', mobile: ''}, //外部参会人
      type: 0,
      range: 2,
      _range: 10, //循环多少次，临时state。
      loopEdit: {
        day: {value: 1, def: 0},
        week: {def: 1, weeks: []}
      },
      moreMeeting: [],
      attendModal: false,
      modalType: '',
      viewOnly: false,
      isHelper: false, //是否为代订人
      appendix: '', //附件链接
      appendixName: '', //附件文件名
      fileList: [], //附件文件列表
      meetingRoomNames: '',
      isSendSms: 0,
      isSendEmail: 0,
      isSendVsk: 1,
      isSendWechat: 1,
      isSendDingTalk: 1,
      isInstall: false,
      cmmaMeeting: 0,
      onlyVideo: 0,
      joinPwd: '',
      callNumber: 0,
      startNow: false,
      startAuto: false,
      autoReconnect: true,
      duration: 15,
      skipConflict: 0,
      ignoreExtends: 1,
      roomAvailable: ["09:00", "19:00"],
      hasSaveSvc: 0,
      remark: ''
    };
  }

  componentWillMount() {
    this.props.dispatch({type: 'meeting/getAllMeetingRoom'}).then(() => {
      const meetingId = getUrlParam('meetingId');
      const reserveMeetingId = getUrlParam('reserveMeetingId') || 0;
      const meeting = this.props.meeting;
      const {onlyVideo} = this.props.meetingInfo;
      let rangeMinute = 15 - (moment().minute() % 15);
      let now = moment();
      let beginTime = moment()
        .hour(now.hour())
        .minute(now.minute())
        .add(rangeMinute, 'minutes');
      if (meeting.roomInfo) {
        beginTime = meeting.roomInfo.beginAt ? meeting.roomInfo.beginAt : beginTime;
        this.setState({moreMeeting: [meeting.roomInfo.room.id.toString()]});
      }
      let endTime = moment(beginTime).add(15, 'minutes');
      if (meeting.roomInfo && meeting.roomInfo.endAt) {
        endTime = meeting.roomInfo.endAt;
      }
      let defaultStartTime =
        moment(beginTime).hours() * 60 + moment(beginTime).minutes();
      defaultStartTime = defaultStartTime > 1410 ? 1410 : defaultStartTime;
      let defaultEndTime = defaultStartTime + 15;
      this.timeList = getTimeLists(this.state.loopInterval);
      const resourceAuth = this.props.allRoomsList.data;
      const roomAvailable = [(resourceAuth.startTime || "00:00"), (resourceAuth.endTime || "00:00")];
      //开始时间
      let loopStartTimes = [],
        loopEndTimes = [];
      const sHour = this.getHours(roomAvailable[0]);
      const eHour = 0 == this.getHours(roomAvailable[1]) ? 24 : this.getHours(roomAvailable[1]);
      const sMin = this.getMins(roomAvailable[0]);
      const eMin = this.getMins(roomAvailable[1]);
      const startSecond = sHour * 60 + sMin;
      const endSecond = eHour * 60 + eMin;
      for (let ll of this.timeList) {
        const second = Number(ll.split(':')[0]) * 60 + Number(ll.split(':')[1]);
        if (second >= startSecond && second < endSecond) {
          loopStartTimes.push(<Option key={second}>{ll}</Option>);
        }
      }
      if (defaultStartTime < startSecond || defaultStartTime > endSecond || defaultEndTime < startSecond || defaultEndTime > endSecond) {
        defaultStartTime = startSecond;
        defaultEndTime = defaultStartTime + 15;
        const startOfDay = beginTime.startOf('day').valueOf();
        beginTime = moment(startOfDay + (endSecond - 15) * 60 * 1000);
        endTime = moment(startOfDay + endSecond * 60 * 1000);
      }
      loopEndTimes = this.getLoopEndTime(
        this.timeList,
        defaultEndTime,
        this.state.loopInterval,
        defaultStartTime
      );
      const userInfo = this.props.userInfo;
      let holder = [],
        isHelper = false;
      if (ROLES_KEY.reserve_helper === userInfo.roleKey) {
        isHelper = true;
      } else {
        holder.push({
          userId: userInfo.userId,
          userName:
            userInfo.firstName +
            (this.locale === ENGLISH ? ' ' : '') +
            userInfo.givenName,
          dept: userInfo.dept,
          position: userInfo.position,
          mobile: userInfo.mobile,
          email: userInfo.email,
          selectType: 0,
          content: userInfo.email + 'undefined'
        });
      }

      this.setState({
        meetingId: meetingId || 0,
        beginTime: beginTime,
        endTime: endTime,
        loopStartLists: loopStartTimes,
        loopEndLists: loopEndTimes,
        viewOnly: this.props.viewOnly,
        holder: holder,
        isHelper: isHelper,
        defaultStartTime: defaultStartTime,
        defaultEndTime: defaultEndTime,
        onlyVideo,
        roomAvailable
      });

      2 == onlyVideo && this.setState({cmmaMeeting: 1, startAuto: true, autoReconnect: true});
      this.props.dispatch({
        type: 'meeting/getMeetTreeData',
        filter: {capacity: 2 == onlyVideo ? 6 : -1}
      });

      if (meetingId > 0 || reserveMeetingId > 0) {
        let state = {};
        this.props.dispatch({
          type: 'meetingInfo/getMeetingInfo',
          payload: {meetingId: meetingId || reserveMeetingId},
        }).then(
          ({status, msg}) => {
            if (status === RES_STATUS.success) {
              const {meeting} = this.props;
              let meetingHolder = [];
              let meetingAttend = [];
              let fulInviteList = meeting.fulInviteList || [];
              if (meeting.allUserInfo && meeting.allUserInfo.holder) {
                meeting.allUserInfo.holder.forEach(each => {
                  meetingHolder.push({
                    userId: each.userId,
                    userName:
                      each.firstName +
                      (this.locale === ENGLISH ? ' ' : '') +
                      each.givenName,
                    dept: each.dept,
                    position: each.position,
                    mobile: each.mobile,
                    email: each.email,
                    selectType: 0,
                    content: each.email + 'undefined',
                    invite: false
                  });
                });
              }
              if (meeting.allUserInfo && meeting.allUserInfo.attends) {
                meeting.allUserInfo.attends.forEach(each => {
                  meetingAttend.push({
                    userId: each.userId,
                    userName:
                      each.firstName +
                      (this.locale === ENGLISH ? ' ' : '') +
                      each.givenName,
                    dept: each.dept,
                    position: each.position,
                    mobile: each.mobile,
                    email: each.email,
                    selectType: 0,
                    content: each.email + 'undefined',
                    invite: false
                  });
                });
              }
              if (meeting.allUserInfo && meeting.allUserInfo.external) {
                meeting.allUserInfo.external.forEach(each => {
                  meetingAttend.push({
                    userId: each.id,
                    userName: each.userName,
                    dept: each.dept,
                    position: each.position,
                    mobile: each.mobile,
                    email: each.email,
                    selectType: 1,
                    content: each.email + 'undefined',
                    telAreaCode: each.telAreaCode,
                    invite: fulInviteList.indexOf(each.id) > -1 ? true : false
                  });
                });
              }
              state.meetingName = meeting.name || '';
              state.moreMeeting = meeting.roomIds ? meeting.roomIds.split(';') : [];
              state.endTime = (!meetingId && reserveMeetingId > 0 && meeting.orignEndTime) ? moment(meeting.orignEndTime) : moment(meeting.endTime);
              state.holder = meetingHolder;
              state.attends = meetingAttend;
              state.isLoop =
                meeting.type > 0 && 1 == getUrlParam('reType') ? true : false;
              state.type = meeting.type;
              state.meetingType = String(meeting.meetingType);
              state.openVideo = meeting.openVideo;
              state.needToSign = meeting.needToSign;
              state.signTime = meeting.signTime;
              state.appendixName = meeting.appendixName;
              state.appendix = meeting.appendix;
              state.fileList = meeting.appendix
                ? [
                  {
                    uid: 1,
                    name: meeting.appendixName,
                    url: meeting.appendix
                  }
                ]
                : null;
              state.meetingRoomNames = meeting.roomNames;
              state.isSendSms = meeting.isSendSms;
              state.isSendEmail = meeting.isSendEmail;
              state.isSendVsk = meeting.isSendVsk;
              state.isSendWechat = meeting.isSendWechat;
              state.isSendDingTalk = meeting.isSendDingTalk;
              state.startNow = !!meeting.isStartNow;
              state.startAuto = !!meeting.startAuto;
              state.autoReconnect = !!meeting.autoReconnect;
              state.duration = Math.round((state.endTime - meeting.startTime) / (1000 * 60));
              state.crossDay = (moment(meeting.startTime).format(TIME_FORMAT.date) !== moment(meeting.endTime).format(TIME_FORMAT.date)) ? 1 : 0;
              state.hasSaveSvc = meeting.hasSaveSvc;
              state.remark = meeting.remark;
              //循环会议的开始和结束时间
              const start = strToSecond(meeting.start);
              let end = strToSecond(meeting.end);
              if (end == 0) {
                end = 1440;
              }
              //循环会议的两个循环规则
              let {day, week} = this.state.loopEdit;
              if (meeting.type == 1) {
                if (meeting.rrule == 0) {
                  day.def = 0;
                  day.value = meeting.exrule;
                } else {
                  day.def = 1;
                }
              } else if (meeting.type == 2) {
                week.def = meeting.rrule;
                week.weeks = meeting.exrule.split(';');
              }
              state.loopEdit = {day: day, week: week};
              if (state.isLoop) {
                //循环会议的时候
                state.loopEndLists = this.getLoopEndTime(
                  this.timeList,
                  end,
                  end - start,
                  start
                );
                state.defaultStartTime = start;
                state.defaultEndTime = end;
                state.loopInterval = end - start;
              }
              //循环类型
              state.loopType = meeting.type == 1 ? 'day' : 'week';
              meeting.range = meeting.range ? meeting.range : "";
              state.range =
                meeting.range == -1 ? 1 : meeting.range.indexOf('-') > 0 ? 3 : 2;
              if (state.range == 2) {
                state._range = meeting.range || 10;
              }
              state.loopEdit = {day: day, week: week};
              state.beginTime = state.isLoop
                ? moment(meeting.startDate)
                : moment(meeting.startTime);
              if (meeting.range.indexOf('-') > 0 && state.isLoop) {
                state.endTime = moment(
                  Date.parse(meeting.range.replace(/-/g, '/'))
                );
              } else {
                state.endTime = (!meetingId && reserveMeetingId > 0 && meeting.orignEndTime) ? moment(meeting.orignEndTime) : moment(meeting.endTime);
              }
              //需要审批的会议一旦申请之后，就不允许再修改会议基本信息，但是可以修改会议服务和议程等信息。
              state.viewOnly =
                this.props.viewOnly ||
                (meetingId &&
                  meeting.audit === MEETING_AUDIT.yes &&
                  meeting.status !== MEETING_STATUS.reject);
              state.cmmaMeeting = meeting.cmmaMeeting;
              if (meeting.cmmaMeeting === 1) {
                const {
                  meetingCtrl: {joinPwd, callNumber}
                } = meeting;
                state.joinPwd = joinPwd;
                state.callNumber = callNumber;
              }
              this.setState(state);
            } else {
              Modal.error({content: msg});
            }
          }
        );
      }
    })
  }

  getBeginDate = beginDate => {
    const roomAvailable = this.state.roomAvailable;
    const eHour = 0 == this.getHours(roomAvailable[1]) ? 24 : this.getHours(roomAvailable[1]);
    const eMin = this.getMins(roomAvailable[1]);
    const endSecond = eHour * 60 + eMin;
    const tempDate = moment(beginDate.valueOf());
    const startOfDay = tempDate.startOf('day').valueOf();
    const maxEndTime = moment(startOfDay + endSecond * 60 * 1000);
    if (beginDate.isAfter(maxEndTime)) {
      beginDate = maxEndTime;
    }
    this.refreshMeetingTree({beginTime: beginDate});
    this.setState({beginTime: beginDate});
  };

  getEndDate = (endDate, type, needAdd = false) => {
    if (this.state.crossDay == 1 && needAdd) {
      const {crossDaysMeetingMinDay = 1} = this.props.meetingPolicy;
      endDate.add(crossDaysMeetingMinDay, 'days');
    }
    console.log("endDate", endDate);
    if (
      !moment(endDate).isSame(moment(endDate).subtract(15, 'minutes'), 'day') &&
      1 == type
    ) {
      let hours = moment(this.state.endTime).hour();
      let minutes = moment(this.state.endTime).minute();
      endDate = moment(endDate)
        .subtract(15, 'minutes')
        .hour(hours)
        .minute(minutes);
    } else if (0 == type) {
      let hours = moment(endDate).hour();
      let minutes = moment(endDate).minute();
      if (59 == minutes && 23 != hours) {
        endDate = moment(endDate).subtract(14, 'minutes');
      }
    }
    const roomAvailable = this.state.roomAvailable;
    const eHour = 0 == this.getHours(roomAvailable[1]) ? 24 : this.getHours(roomAvailable[1]);
    const eMin = this.getMins(roomAvailable[1]);
    const endSecond = eHour * 60 + eMin;
    const tempDate = moment(endDate.valueOf());
    const startOfDay = tempDate.startOf('day').valueOf();
    const maxEndTime = moment(startOfDay + endSecond * 60 * 1000);
    if (endDate.isAfter(maxEndTime)) {
      endDate = maxEndTime;
    }
    this.refreshMeetingTree({endTime: endDate});
    this.setState({endTime: endDate});
  };

  onMeetingChange = (value, label, extra) => {
    if (!value) return;
    if (1 == this.props.meetingPolicy.showMutilRoomsChoice) {
      this.setState({moreMeeting: value});
    } else {
      if (!isNaN(value) || String(value).indexOf("common-") > -1) {
        this.setState({moreMeeting: [String(value)]});
      }
    }
  };

  //循环结束时间,endTime结束时间的第一个值
  getLoopEndTime = (timeList, endTime, loopInterval, start) => {
    const eHour = 0 == this.getHours(this.state.roomAvailable[1]) ? 24 : this.getHours(this.state.roomAvailable[1]);
    const eMin = this.getMins(this.state.roomAvailable[1]);
    const endSecond = eHour * 60 + eMin;
    let loopEndTimes = [];
    for (let ll of timeList) {
      const second = Number(ll.split(':')[0]) * 60 + Number(ll.split(':')[1]);
      if (second > start && second <= endSecond) {
        let inDiv = '';
        if (second - start < 60) {
          inDiv =
            second -
            start +
            this.props.intl.formatMessage({id: 'booking_minutes'});
        } else {
          inDiv =
            Number((second - start) / 60).toFixed(2) +
            this.props.intl.formatMessage({id: 're_hour'});
        }
        loopEndTimes.push(<Option key={second}>{`${ll}(${inDiv})`}</Option>);
      }
    }
    if (endTime > 0 && endSecond == 1440) {
      //超过一天的时候
      let inDiv = '';
      let interval = 1440 - start;
      if (interval < 60) {
        inDiv =
          interval +
          this.props.intl.formatMessage({id: 'booking_minutes'});
      } else {
        inDiv =
          Number(interval / 60).toFixed(2) +
          this.props.intl.formatMessage({id: 're_hour'});
      }
      loopEndTimes.push(<Option key={1440}>{`00:00(${inDiv})`}</Option>);
    }
    return loopEndTimes;
  };

  //检查开始时间和结束时间修改会议下拉框数据
  refreshMeetingTree = value => {
    if (value.hasOwnProperty('capacity')) {
      if (value.capacity === 6) {
        // 选择视频会议时，需要移除已选择的普通会议室
        const {moreMeeting} = this.state;
        const {allRoomsList} = this.props;
        const newIds = [];
        if (
          allRoomsList &&
          allRoomsList.list &&
          allRoomsList.list.length > 0 &&
          moreMeeting.length > 0
        ) {
          moreMeeting.forEach(m => {
            allRoomsList.list.some(
              r => r.id === Number(m) && r.capacity === 6
            ) && newIds.push(m);
          });
        }
        this.setState({moreMeeting: newIds});
      }
      this.props.dispatch({
        type: 'meeting/getMeetTreeData',
        filter: {capacity: value.capacity}
      });
    }
    if (value.hasOwnProperty('beginTime')) {
      if (this.state.endTime > value.beginTime) {
        this.props.dispatch({
          type: 'meeting/getMeetTreeData',
          filter: {
            flag: 3,
            locale: this.locale,
            startTime: value.beginTime,
            endTime: this.state.endTime
          }
        });
      }
    }
    if (value.hasOwnProperty('endTime')) {
      if (this.state.beginTime < value.endTime) {
        this.props.dispatch({
          type: 'meeting/getMeetTreeData',
          filter: {
            flag: 3,
            locale: this.locale,
            startTime: this.state.beginTime,
            endTime: value.endTime
          }
        });
      }
    }
    if (value.hasOwnProperty('loopBeginTime')) {
      let end = moment(value.loopBeginTime).add(15, 'minutes');
      this.props.dispatch({
        type: 'meeting/getMeetTreeData',
        filter: {
          flag: 3,
          locale: this.locale,
          startTime: value.loopBeginTime,
          endTime: end
        }
      });
    }
    if (value.hasOwnProperty('loopEndTime')) {
      if (
        value.loopEndTime >
        moment(this.state.beginTime)
          .startOf('day')
          .minutes(this.state.defaultStartTime)
      ) {
        this.props.dispatch({
          type: 'meeting/getMeetTreeData',
          filter: {
            flag: 3,
            locale: this.locale,
            startTime: moment(this.state.beginTime)
              .startOf('day')
              .minutes(this.state.defaultStartTime),
            endTime: value.loopEndTime
          }
        });
      }
    }
  };

  //选择参会人
  searchUsers = value => {
    if (
      this.state.holder &&
      value.some(id => {
        return id == this.state.holder[0];
      })
    ) {
      Modal.warning({
        content: this.props.intl.formatMessage({
          id: 'attend_holder_conflict'
        }),
        okText: '确认'
      });
      this.setState({attends: $this.state.attends});
      return;
    }
    let numbers = 1000;

    if (
      value.length > Number(numbers - 1) &&
      value.length > this.state.attends.length
    ) {
      //不能选择超过会议室容纳人数
      Modal.warning({
        content: this.props.intl.formatMessage({id: 'book_meeting_attendee'}),
        okText: '确认'
      });
      return;
    }
    this.setState({attends: value});
  };

  //选择主持人
  searchHolder = value => {
    if (value.length > 1) {
      //主持人只有一个
      value.splice(0, 1);
    }

    if (
      this.state.attends &&
      this.state.attends.some(id => {
        return id == value[0];
      })
    ) {
      const $this = this;
      Modal.warning({
        content: this.props.intl.formatMessage({
          id: 'attend_holder_conflict'
        }),
        okText: '确认'
      });
      $this.setState({holder: [], position: {}});
      return;
    }
    this.setState({holder: value, position: {}});
  };

  componentDidMount() {
    this.setState({signTime: this.props.meetingInfo.signTime});
  }

  componentWillReceiveProps(nextProps) {
    if (!getUrlParam('meetingId') && !this.state.isInstall) {
      if (!_.isEmpty(nextProps.noticeConfig)) {
        const noticeConfig = nextProps.noticeConfig;
        this.setState({
          isInstall: true,
          isSendSms: noticeConfig.isSendSms || 0,
          isSendEmail: noticeConfig.isSendEmail || 0,
          isSendVsk: noticeConfig.isSendVsk || 0,
          isSendWechat: noticeConfig.isSendWechat || 0,
          isSendDingTalk: noticeConfig.isSendDingTalk || 0
        });
      }
      if (nextProps.meetingInfo.signTime) {
        this.setState({signTime: nextProps.meetingInfo.signTime});
      }
    }
    if (
      getUrlParam('meetingId') &&
      this.state.meetingId != getUrlParam('meetingId')
    ) {
      this.setState({meetingId: getUrlParam('meetingId')});
    }
  }

  getHours = (str) => {
    if (str) {
      return Number(str.split(":")[0]);
    } else {
      return 0;
    }
  };

  getMins = (str) => {
    if (str) {
      return Number(str.split(":")[1]);
    } else {
      return 0;
    }
  };

  filterDateHours = () => {
    if (this.state.crossDay == 1) {
      return [];
    }
    const sHour = this.getHours(this.state.roomAvailable[0]);
    const eHour = 0 == this.getHours(this.state.roomAvailable[1]) ? 24 : this.getHours(this.state.roomAvailable[1]);
    if (moment.isMoment(this.state.beginTime)) {
      const beginTime = this.state.beginTime.clone();
      if (moment.isMoment(beginTime) && moment().startOf('day').isSame(beginTime.startOf('day'))) {//当天
        let result = [];
        for (let i = 0; i < 24; i++) {
          if (i < moment().hour() || i < sHour || i > eHour)
            result.push(i);
        }
        return result;
      } else {
        let result = [];
        for (let i = 0; i < 24; i++) {
          if (i < sHour || i > eHour)
            result.push(i);
        }
        return result;
      }
    }
    return [];
  };

  filterDateMinutes = (selectHour) => {
    const sHour = this.getHours(this.state.roomAvailable[0]);
    const eHour = 0 == this.getHours(this.state.roomAvailable[1]) ? 24 : this.getHours(this.state.roomAvailable[1]);
    const sMin = this.getMins(this.state.roomAvailable[0]);
    const eMin = this.getMins(this.state.roomAvailable[1]);
    let result = [];
    for (let i = 0; i < 60; i++) {
      result.push(i);
    }
    result = result.filter(value => value % 15 !== 0);
    if (sHour == selectHour) {
      for (let j = 1; j < 4; j++) {
        if (j * 15 < sMin) {
          result.push(j * 15);
        }
      }
    }
    if (eHour == selectHour) {
      for (let j = 1; j < 4; j++) {
        if (j * 15 > eMin) {
          result.push(j * 15);
        }
      }
    }
    return result;
  };

  filterEndDateMinutes = (selectHour) => {
    const sHour = this.getHours(this.state.roomAvailable[0]);
    const eHour = 0 == this.getHours(this.state.roomAvailable[1]) ? 24 : this.getHours(this.state.roomAvailable[1]);
    const sMin = this.getMins(this.state.roomAvailable[0]);
    const eMin = this.getMins(this.state.roomAvailable[1]);
    let result = [];
    for (let i = 0; i < 60; i++) {
      result.push(i);
    }
    result = result.filter(value => value % 15 !== 0);

    if (selectHour == 23) {
      result = result.filter(value => value % 59 !== 0);
    }
    if (sHour == selectHour) {
      for (let j = 1; j < 4; j++) {
        if (j * 15 < sMin) {
          result.push(j * 15);
        }
      }
    }
    if (eHour == selectHour) {
      for (let j = 1; j < 4; j++) {
        if (j * 15 > eMin) {
          result.push(j * 15);
        }
      }
    }
    return result;
  };

  disabledBeginDate = current => {
    return (
      current &&
      current.valueOf() <
      moment()
        .startOf('day')
        .valueOf()
    );
  };

  render() {
    const {
      intl,
      meeting,
      meetingTree,
      userList,
      meetingPolicy: {cmmaMeetingState = 1, showMeetingSign = 1, showMutilRoomsChoice = 1, allowMeetingCrossDays = 0, showMeetingSvc = 0}
    } = this.props;
    let {noticeKeys = []} = this.props;
    noticeKeys = noticeKeys.filter(
      key => key == 'smsState' || key == 'emailState'
    );
    const {status, audit} = meeting;
    const {
      onlyVideo,
      cmmaMeeting,
      joinPwd,
      callNumber,
      startNow,
      startAuto,
      autoReconnect,
      duration,
      isLoop
    } = this.state;

    let users = [];
    if (userList) {
      userList.forEach(user => {
        users.push(
          <Option
            key={
              user.userId +
              '#' +
              user.firstName +
              (this.locale === ENGLISH ? ' ' : '') +
              user.givenName
            }
          >
            {user.firstName + ' ' + user.givenName}
          </Option>
        );
      });
    }
    let holderValue =
      this.state.holder && this.state.holder.length > 0
        ? [this.state.holder[0].userId + '#' + this.state.holder[0].userName]
        : [];

    let roomSignLabel = [],
      hasSign = false,
      hasVideoRoom = false;
    if (
      this.props.allRoomsList &&
      this.props.allRoomsList.list &&
      this.state.moreMeeting &&
      this.state.moreMeeting.length > 0
    ) {
      this.props.allRoomsList.list.forEach(each => {
        if (
          this.state.moreMeeting.indexOf(String(each.id)) > -1 ||
          this.state.moreMeeting.indexOf(String('common-' + each.id)) > -1
        ) {
          let signValue = '';
          if (6 == each.capacity) {
            //多功能厅  才能开启直录播
            hasVideoRoom = true;
          }
          if (-1 == each.sign) {
            signValue = this.props.intl.formatMessage({
              id: 'service_sign_noneed'
            });
          } else if (0 == each.sign) {
            hasSign = true;
            signValue = this.props.intl.formatMessage({
              id: 'service_sign_anonymous'
            });
          } else if (1 == each.sign) {
            hasSign = true;
            signValue = this.props.intl.formatMessage({
              id: 'service_sign_password'
            });
          } else if (2 == each.sign) {
            hasSign = true;
            signValue = this.props.intl.formatMessage({
              id: 'service_sign_Invitation'
            });
          } else if (3 == each.sign) {
            hasSign = true;
            signValue = this.props.intl.formatMessage({
              id: 'service_sign_qr'
            });
          } else if (4 == each.sign) {
            hasSign = true;
            signValue = this.props.intl.formatMessage({
              id: 'service_sign_face'
            });
          }
          if (roomSignLabel.length != 0) {
            roomSignLabel.push(<span key={'sep-' + each.id}><br/></span>);
          }
          roomSignLabel.push(
            <span key={'romm-' + each.id}>
              <span>{intl.locale === 'en_US' ? each.nameEn : each.name}</span>
              <span>(</span>
              <span>{signValue}</span>
              <span>) </span>
            </span>
          );
        }
      });
    }
    const svcApplied = this.checkSvcApplied();

    //循环会议
    let loopDiv = this.getLoopDiv(svcApplied);

    const columns = [
      {
        title: intl.formatMessage({id: 'index_username'}),
        key: 'userName',
        className: 'user-name-col',
        render: record => {
          if (record.selectType == 0) {
            return (
              <span className="meeting-inner-attend">{record.userName}</span>
            );
          } else {
            return (
              <span className="meeting-outer-attend">{record.userName}</span>
            );
          }
        }
      },
      {
        title: intl.formatMessage({id: 'tel'}),
        key: 'mobile',
        render: record => {
          let mobile = record.mobile || '';
          let telAreaCode = record.telAreaCode || '';
          if (record.selectType == 0 || !telAreaCode || !mobile || mobile.indexOf('+') == 0) {
            return <span className="meeting-outer-attend">{mobile}</span>;
          } else {
            return <span className="meeting-outer-attend">{telAreaCode + mobile}</span>;
          }
        }
      },
      {
        title: intl.formatMessage({id: 'index_email'}),
        key: 'email',
        render: record => {
          return <span className="meeting-outer-attend">{record.email}</span>;
        }
      },
      {
        title: intl.formatMessage({id: 'main_meeting_type'}),
        key: 'selectType',
        render: record => {
          if (record.selectType == 0) {
            return (
              <span className="meeting-inner-attend">
                <FormattedMessage id="meeting_attends_inner"/>
              </span>
            );
          } else {
            return (
              <span className="meeting-outer-attend">
                <FormattedMessage id="meeting_attends_outer"/>
              </span>
            );
          }
        }
      }
    ];
    if (1 == this.props.inviteFlag) {
      columns.push({
        title: intl.formatMessage({id: 'meeting_book_column_invite'}),
        key: 'invite',
        render: record => {
          if (record.selectType == 1) {
            return (
              <Checkbox
                disabled={this.state.viewOnly}
                checked={record.invite}
                onClick={e => {
                  // UIEvent​.detail
                  if (e.detail === 1) {
                    let tempData = this.state.attends || [];
                    tempData &&
                    tempData.map(item => {
                      if (item.userId == record.userId) {
                        item.invite = e.target.checked;
                      }
                    });
                    this.setState({attends: tempData});
                  }
                }}
              />
            );
          }
        }
      });
    }
    if (!this.state.viewOnly) {
      columns.push({
        title: intl.formatMessage({id: 'mc_table_option'}),
        key: 'operate',
        className: 'operate-col',
        render: record => {
          const {fuIds = '', members = ''} = this.props.meeting;
          const membList = members.split(';');
          const fuList = fuIds.split(';');
          let operateDiv = [];
          operateDiv.push(
            <span
              key="table-operate-del"
              className="meeting-attend-del"
              onClick={() => {
                let index = -1;
                this.state.attends.map((item, i) => {
                  if (String(item.userId) === String(record.userId)) index = i;
                });
                let userList = _.cloneDeep(this.state.attends);
                if (index >= 0) {
                  userList.splice(index, 1);
                }
                this.setState({attends: userList});
              }}
            >
              <IconTip
                title={this.props.intl.formatMessage({
                  id: 'modal_manage_delete'
                })}
                type="shanchu"
              />
            </span>
          );
          if (
            (0 == record.selectType && membList.indexOf(record.userId) > -1) ||
            (1 == record.selectType &&
              fuList.indexOf(String(record.userId)) > -1)
          ) {
            if (this.state.meetingId && this.state.meetingId > 0) {
              //编辑会议
              const {audit, status} = this.props.meeting;
              if (
                !(
                  audit === MEETING_AUDIT.yes &&
                  status !== MEETING_STATUS.pending
                )
              ) {
                //是审批会议但不是审批通过状态的不允许发送通知
                operateDiv.push(
                  <span
                    key="table-operate-send"
                    className="meeting-attend-send"
                    onClick={() => {
                      this.props.dispatch({
                        type: 'meetingInfo/sendMsgToUser',
                        payload: {
                          meetingId: this.state.meetingId,
                          userId: record.userId,
                          userType: record.selectType
                        }
                      });
                    }}
                  >
                    <IconTip
                      title={this.props.intl.formatMessage({
                        id: 'meeting_send_msg'
                      })}
                      type="fasongtongzhi"
                    />
                  </span>
                );
              }
            }
          }
          return <span>{operateDiv}</span>;
        }
      });
    } else if (
      status === MEETING_STATUS.pending &&
      audit === MEETING_AUDIT.yes
    ) {
      //审批通过，允许单个发送通知
      columns.push({
        title: intl.formatMessage({id: 'mc_table_option'}),
        key: 'operate',
        className: 'operate-col',
        render: record => {
          const {fuIds = '', members = ''} = this.props.meeting;
          const membList = members.split(';');
          const fuList = fuIds.split(';');
          let operateDiv = [];
          if (
            (0 == record.selectType && membList.indexOf(record.userId) > -1) ||
            (1 == record.selectType &&
              fuList.indexOf(String(record.userId)) > -1)
          ) {
            if (this.state.meetingId && this.state.meetingId > 0) {
              //编辑会议
              const {audit, status} = this.props.meeting;
              if (
                !(
                  audit === MEETING_AUDIT.yes &&
                  status !== MEETING_STATUS.pending
                )
              ) {
                //是审批会议但不是审批通过状态的不允许发送通知
                operateDiv.push(
                  <span
                    key="table-operate-send"
                    className="meeting-attend-send"
                    onClick={() => {
                      this.props.dispatch({
                        type: 'meetingInfo/sendMsgToUser',
                        payload: {
                          meetingId: this.state.meetingId,
                          userId: record.userId,
                          userType: record.selectType
                        }
                      });
                    }}
                  >
                    <IconTip title={this.props.intl.formatMessage({id: 'meeting_send_msg'})} type="fasongtongzhi"/>
                  </span>
                );
              }
            }
          }
          return <span>{operateDiv}</span>;
        }
      });
    }

    const needAudit = this.checkNeedAudit();

    const noticeConfig = this.props.noticeConfig || {};
    let sendSmsDisable = noticeConfig.sendSmsDisable || 0;
    let sendEmailDisable = noticeConfig.sendEmailDisable || 0;
    let sendVskDisable = noticeConfig.sendVskDisable || 0;
    let sendWechatDisable = noticeConfig.sendWechatDisable || 0;
    let sendDingTalkDisable = noticeConfig.sendDingTalkDisable || 0;

    let _password = null;
    return (
      <div>
        <div className="meeting-detail-opt">
          {this.state.attendModal && (
            <Modal width={760} style={{top: 75}} footer={null} visible>
              <div className="meeting-user-select new_table">
                <UserSelect
                  intl={intl}
                  dispatch={this.props.dispatch}
                  modalType={this.state.modalType}
                  selected={this.state.attends}
                  holder={this.state.holder}
                  allDeptData={this.props.allDeptData}
                  userByDept={this.props.userByDept}
                  roomId={this.state.moreMeeting.join(SEMICOLON)}
                  moreMeeting={this.state.moreMeeting}
                  allRoomsList={this.props.allRoomsList}
                  openModal={value => this.setState({attendModal: value})}
                  changeHolder={value => this.searchHolder(value)}
                  onChange={value => this.searchUsers(value)}
                  userInfo={this.props.userInfo}
                  inviteFlag={this.props.inviteFlag}
                />
              </div>
            </Modal>
          )}
          {1 === cmmaMeetingState &&
          0 === onlyVideo && (
            <div className="append">
              <p className="name">
                <FormattedMessage id="main_meeting_type"/>：
              </p>
              <Select
                key="meeting-type"
                className="meeting-type"
                disabled={this.state.viewOnly || svcApplied || 1 == onlyVideo}
                value={String(cmmaMeeting)}
                onChange={value => {
                  if (value == '0') {
                    this.setState({
                      cmmaMeeting: Number(value),
                      startAuto: false,
                      autoReconnect: false
                    });
                  } else {
                    this.setState({
                      cmmaMeeting: Number(value),
                      startAuto: true,
                      autoReconnect: true
                    });
                  }
                  this.refreshMeetingTree({
                    capacity: Number(value) === 1 ? 6 : null
                  });
                }}
              >
                <Option value={'0'}>
                  <FormattedMessage id="main_meeting_cmma_normal"/>
                </Option>
                {0 == onlyVideo && (
                  <Option value={'1'}>
                    <FormattedMessage id="main_meeting_cmma_video"/>
                  </Option>
                )}
              </Select>
            </div>
          )}
          <div className="append">
            <p className="name"><FormattedMessage id='main_meeting_title'/>：</p>

            <input disabled={this.state.viewOnly || svcApplied}
                   className={`meeting-title${cmmaMeeting === 1 ? ' cmma' : ''}`} maxLength="50" type="text"
                   placeholder={intl.formatMessage({id: 'main_meeting_title'})}
                   value={this.state.meetingName}
                   onChange={this.onMeetingNameChange}/>
            <input type="text" style={{opacity: "0", width: "0.1px"}}/>
            <input type="password" style={{opacity: "0", width: "0.1px"}}/>
            {
              cmmaMeeting === 1 &&
              <input disabled={this.state.viewOnly || svcApplied}
                     autoComplete="off"
                     className="join-pwd" maxLength="10" type="text"
                     placeholder={intl.formatMessage({id: 'main_meeting_cmma_pwd'})}
                     value={joinPwd}
                     ref={ref => (_password = ref)}
                     onFocus={() => {
                       if (_password) {
                         _password.type = 'password';
                       }
                     }}
                     onChange={(e) => this.setState({joinPwd: e.target.value})}/>
            }
          </div>
          <div className="append">
            <MoreMeetingIndex
              showType={true}
              message="main_search_content"
              meetingTree={meetingTree}
              intl={intl}
              disabled={this.state.viewOnly || svcApplied}
              showCommon={true}
              onMeetingChange={this.onMeetingChange}
              selected={this.state.moreMeeting}
              needAudit={needAudit}
              selectRoomName={this.state.meetingRoomNames}
              cmmaMeeting={cmmaMeeting}
              current={[]}
              multiple={1 == showMutilRoomsChoice ? true : false}
              treeCheckable={1 == showMutilRoomsChoice ? true : false}
            />
          </div>
          {!needAudit && (
            <div className="append">
              <p className="name" style={{float: 'left', paddingTop: '5px'}}>
                <FormattedMessage id="meeting_detail_start_now"/> ：
              </p>
              <Switch
                disabled={
                  this.state.viewOnly ||
                  this.state.meetingId > 0
                }
                checked={startNow}
                onChange={value => {
                  this.setState({
                    startNow: value,
                    isLoop: value ? false : isLoop
                  });
                  if (value) {
                    this.setState({needToSign: 1});
                  } else {
                    this.setState({needToSign: 0});
                  }
                }}
              />
              {startNow && (
                <InputNumber
                  className="meeting_duration"
                  value={duration}
                  disabled={this.state.viewOnly || svcApplied}
                  min={15}
                  max={1000}
                  onChange={value => {
                    this.setState({duration: value || 15});
                  }}
                  formatter={value =>
                    `${value} ` + intl.formatMessage({id: 'booking_minutes'})
                  }
                  //formatter={value => `${value} 分钟`}
                />
              )}
            </div>
          )}
          {!isLoop &&
          !startNow && !!allowMeetingCrossDays && <div className="append">
            <p className="name" style={{float: 'left', paddingTop: '5px'}}>
              <FormattedMessage id="long_term_meeting_label"/>
            </p>
            <Switch
              disabled={this.state.viewOnly}
              checked={this.state.crossDay === 1}
              onChange={value => {
                this.setState({
                  crossDay: value ? 1 : 0
                }, () => {
                  let newTimeStr = moment(this.state.beginTime).format(TIME_FORMAT.date) + " " + moment(this.state.endTime).format(TIME_FORMAT.time);
                  let newEndTime = moment(newTimeStr, TIME_FORMAT.date_time);
                  this.getEndDate(newEndTime, 0, true);
                });

              }}
            />
          </div>}

          {!isLoop &&
          !startNow && (
            <div className="append">
              <span className="name">
                <FormattedMessage id="main_meeting_startTime"/>：
              </span>
              <span className="message">
                <DatePicker
                  disabled={this.state.viewOnly || svcApplied}
                  showToday={false}
                  style={{width: 115, marginRight: 14}}
                  onChange={value => {
                    this.getBeginDate(value);
                    this.getEndDate(
                      value ? moment(value).add(15, 'minutes') : value,
                      1,
                      true
                    );
                  }}
                  disabledDate={this.disabledBeginDate}
                  value={this.state.beginTime}
                  allowClear={false}
                />
                <TimePicker
                  disabled={this.state.viewOnly || svcApplied}
                  hideDisabledOptions={true}
                  disabledHours={this.filterDateHours}
                  onChange={this.getBeginDate}
                  value={this.state.beginTime}
                  disabledMinutes={this.filterDateMinutes}
                  allowClear={false}
                  format="HH:mm"
                  defaultValue=""
                  className="time-select"
                />
                &nbsp;~&nbsp;
                {this.state.crossDay == 1 && <DatePicker
                  disabled={this.state.viewOnly || svcApplied}
                  showToday={false}
                  style={{width: 115, marginRight: 14}}
                  onChange={value => {
                    this.getEndDate(value, 0);
                  }}
                  disabledDate={this.disabledBeginDate}
                  value={this.state.endTime}
                  allowClear={false}
                />}
                <TimePicker
                  disabled={this.state.viewOnly || svcApplied}
                  className="ant-icon-clear time-select"
                  hideDisabledOptions={true}
                  onChange={value => {
                    this.getEndDate(value, 0);
                  }}
                  value={this.state.endTime}
                  disabledHours={this.filterDateHours}
                  disabledMinutes={this.filterEndDateMinutes}
                  format="HH:mm"
                />
                {false && <span style={{color: '#4680FF', marginLeft: "10px", cursor: "pointer"}}
                                onClick={() => this.setState({crossDay: this.state.crossDay === 1 ? 0 : 1})}>
                {this.state.crossDay === 1 ? '普通会议' : '长期会议'}
              </span>}
              </span>
            </div>
          )}
          {this.getAppendixDiv(needAudit)}
          <div className="append">
            <div className="detail-flex-div"/>
            <p className="name">
              <FormattedMessage id="main_meeting_holder"/>：
            </p>
            <label className="new-peo">
              {this.state.viewOnly || !this.state.isHelper || svcApplied ? (
                <span>
                {holderValue &&
                holderValue.length > 0 &&
                holderValue[0].indexOf('#') > -1
                  ? holderValue[0].split('#')[1]
                  : holderValue}
              </span>
              ) : (
                <Select
                  onFocus={() =>
                    this.setState({attendModal: true, modalType: HOLDER_MODAL})
                  }
                  mode="multiple"
                  dropdownStyle={{display: 'none'}}
                  placeholder={intl.formatMessage({id: 'main_meeting_holder'})}
                  notFoundContent={intl.formatMessage({
                    id: 'main_meeting_no_data'
                  })}
                  value={holderValue}
                >
                  {users}
                </Select>
              )}
            </label>
          </div>
          <div className="append">
            <p className="name" style={{float: 'left', paddingTop: '8px'}}>
              <FormattedMessage id="main_meeting_attend"/>：
            </p>
            <label className="new-peo attend-list">
              {this.state.viewOnly ? null : (
                <div
                  className="add-font btn-attend"
                  onClick={e => {
                    e.preventDefault();
                    this.setState({attendModal: true, modalType: ATTEND_MODAL});
                  }}
                >
                  <i className="iconfont attend-icon">+</i>
                  <span className="add-span">
                  <FormattedMessage id="add"/>
                </span>
                </div>
              )}
              {this.state.attends &&
              this.state.attends.length > 0 && (
                <Table
                  rowKey={record => record.userId}
                  dataSource={this.state.attends}
                  columns={columns}
                  className={`meeting-detail-user-table`}
                  pagination={{
                    pageSize: 4,
                    hideOnSinglePage: true
                  }}
                />
              )}
            </label>
          </div>
          {cmmaMeeting === 1 && (
            <div className="append">
              <p className="name" style={{float: 'left', paddingTop: '5px'}}>
                <FormattedMessage id="meeting_info_initiate_auto"/>：
              </p>
              <Switch
                checked={startAuto}
                disabled={this.state.viewOnly}
                onChange={value => this.setState({startAuto: value})}
              />
            </div>
          )}
          {cmmaMeeting === 1 && (
            <div className="append">
              <p className="name" style={{float: 'left', paddingTop: '5px'}}>
                <FormattedMessage id="meeting_info_reconnect_auto"/>：
              </p>
              <Switch
                checked={autoReconnect}
                disabled={this.state.viewOnly}
                onChange={value => this.setState({autoReconnect: value})}
              />
            </div>
          )}
          {this.state.startNow == 0 &&
          hasSign &&
          showMeetingSign == 1 && (
            <div className="append">
              <p className="name" style={{float: 'left', paddingTop: '5px'}}>
                <FormattedMessage id="main_is_sign"/>：
              </p>
              <label className="new-peo">
                <Switch
                  disabled={
                    this.state.viewOnly || svcApplied || this.state.startNow
                  }
                  checked={0 == this.state.needToSign && hasSign ? true : false}
                  onChange={value => {
                    this.setState({needToSign: value ? 0 : 1});
                  }}
                />
                <div
                  className={
                    this.state.needToSign == 0 && hasSign ? '' : 're-hidden'
                  }
                >
                  <div className="sign-item room-sign">
                    <span className="label">
                      <FormattedMessage id="report_meeting_name"/>
                      &nbsp;:
                    </span>
                    <span className="content">{roomSignLabel}</span>
                  </div>
                  <div className="sign-item">
                    <span className="label" style={intl.locale === 'zh_CN' ? {} : {flex: "0 0 120px"}}>
                      <FormattedMessage id="sign_meeting_check_in_time"/>
                      &nbsp;:
                    </span>
                    <span className="signTime-label">
                      <FormattedMessage id="sign_meeting_befer_or_after"/>
                    </span>
                    <InputNumber
                      className="singTime-input"
                      disabled={this.state.viewOnly || svcApplied}
                      min={1}
                      max={60}
                      value={this.state.signTime}
                      onChange={value => {
                        if (value > this._maxTime) {
                          return;
                        }
                        this.setState({signTime: value});
                      }}
                    />
                    <span className="signTime-label">
                      <FormattedMessage id="booking_minutes"/>
                    </span>
                  </div>
                </div>
              </label>
            </div>
          )}

          <div className="append">
            <p className="name" style={{float: 'left', paddingTop: '5px'}}>
              <FormattedMessage id="main_notice_type"/>：
            </p>
            {noticeKeys.length == 0 ? (
              <label
                className="notice-label"
                style={{float: 'left', paddingTop: '5px'}}
              >
                无
              </label>
            ) : null}
            {noticeKeys.indexOf('smsState') > -1 ? (
              <label>
                <label className="notice-label">
                  <FormattedMessage id="main_meeting_message"/>
                </label>
                <Switch
                  disabled={this.state.viewOnly || 0 == sendSmsDisable}
                  checked={1 == this.state.isSendSms ? true : false}
                  onChange={value => {
                    this.setState({isSendSms: value ? 1 : 0});
                  }}
                />
              </label>
            ) : null}
            {noticeKeys.indexOf('emailState') > -1 ? (
              <label>
                <label className="notice-label">
                  <FormattedMessage id="notice_manage_email"/>
                </label>
                <Switch
                  disabled={this.state.viewOnly || 0 == sendEmailDisable}
                  checked={1 == this.state.isSendEmail ? true : false}
                  onChange={value => {
                    this.setState({isSendEmail: value ? 1 : 0});
                  }}
                />
              </label>
            ) : null}
            {noticeKeys.indexOf('vskMsgState') > -1 ? (
              <label>
                <label className="notice-label">
                  <FormattedMessage id="notice_manage_vsk"/>
                </label>
                <Switch
                  disabled={this.state.viewOnly || 0 == sendVskDisable}
                  checked={1 == this.state.isSendVsk ? true : false}
                  onChange={value => {
                    this.setState({isSendVsk: value ? 1 : 0});
                  }}
                />
              </label>
            ) : null}
            {noticeKeys.indexOf('weiXinState') > -1 ? (
              <label>
                <label className="notice-label">
                  <FormattedMessage id="notice_manage_wechat"/>
                </label>
                <Switch
                  disabled={this.state.viewOnly || 0 == sendWechatDisable}
                  checked={1 == this.state.isSendWechat ? true : false}
                  onChange={value => {
                    this.setState({isSendWechat: value ? 1 : 0});
                  }}
                />
              </label>
            ) : null}
            {noticeKeys.indexOf('ddMsgState') > -1 ? (
              <label>
                <label className="notice-label">
                  <FormattedMessage id="notice_manage_dd"/>
                </label>
                <Switch
                  disabled={this.state.viewOnly || 0 == sendDingTalkDisable}
                  checked={1 == this.state.isSendDingTalk ? true : false}
                  onChange={value => {
                    this.setState({isSendDingTalk: value ? 1 : 0});
                  }}
                />
              </label>
            ) : null}
          </div>

          <div className="append">
            <p className="name"><FormattedMessage id='main_meeting_remark'/>：</p>
            <input disabled={this.state.viewOnly || svcApplied}
                   className="meeting-title" maxLength="50" type="text"
                   placeholder={intl.formatMessage({id: 'meeting_placeholder_remark'})}
                   value={this.state.remark}
                   onChange={e => this.setState({remark: e.target.value})}/>
          </div>

          {cmmaMeeting === 1 &&
          callNumber > 0 && (
            <div className="append">
              <p className="name" style={{float: 'left', paddingTop: '5px'}}>
                <FormattedMessage id="meeting_info_cospaces"/>：
              </p>
              <span className="meeting-number">{callNumber}</span>
            </div>
          )}
          {(1 == this.props.meetingPolicy.cycleMeetingSwitch) && <div
            className="append"
            style={{
              display:
                !this.state.meetingId || this.state.isLoop ? 'block' : 'none'
            }}
          >
            <p className="name" style={{marginTop: '-2px'}}>
              <FormattedMessage id="main_meeting_cycle"/>：
            </p>
            <label className="new-peo">
              <Switch
                disabled={
                  this.state.viewOnly ||
                  svcApplied ||
                  (this.state.isLoop && !!this.state.meetingId) ||
                  startNow
                } //循环会议在编辑时不允许关闭循环开关
                checked={this.state.isLoop}
                onChange={isLoop => {
                  let {
                    beginTime,
                    endTime,
                    defaultStartTime,
                    defaultEndTime,
                    loopInterval,
                    loopEndLists
                  } = this.state;
                  if (isLoop) {
                    //打开循环设置开关，将普通会议的开始时间结束时间同步到循环会议的设置中
                    defaultStartTime =
                      beginTime.hours() * 60 + beginTime.minutes();
                    defaultEndTime = endTime.hours() * 60 + endTime.minutes();
                    defaultEndTime = defaultEndTime == 1439 ? defaultEndTime + 1 : defaultEndTime;
                    defaultEndTime =
                      defaultEndTime > defaultStartTime
                        ? defaultEndTime
                        : defaultStartTime + 15;
                    const sHour = this.getHours(this.state.roomAvailable[0]);
                    const eHour = 0 == this.getHours(this.state.roomAvailable[1]) ? 24 : this.getHours(this.state.roomAvailable[1]);
                    const sMin = this.getMins(this.state.roomAvailable[0]);
                    const eMin = this.getMins(this.state.roomAvailable[1]);
                    const startSecond = sHour * 60 + sMin;
                    const endSecond = eHour * 60 + eMin;
                    if (defaultStartTime < startSecond || defaultStartTime > endSecond || defaultEndTime < startSecond || defaultEndTime > endSecond) {
                      defaultStartTime = startSecond;
                      defaultEndTime = defaultStartTime + 15;
                    }
                    loopInterval = defaultEndTime - defaultStartTime;
                    loopEndLists = this.getLoopEndTime(
                      this.timeList,
                      defaultEndTime,
                      loopInterval,
                      defaultStartTime
                    );
                    this.setState({
                      defaultStartTime,
                      defaultEndTime,
                      loopInterval,
                      loopEndLists
                    });
                  } else {
                    //关闭循环设置开关，将循环会议的开始时间和结束时间同步到普通会议中
                    const startOfDay = beginTime.startOf('day').valueOf();
                    defaultEndTime = defaultEndTime == 1440 ? defaultEndTime - 1 : defaultEndTime;
                    this.setState({
                      beginTime: moment(
                        startOfDay + defaultStartTime * 60 * 1000
                      ),
                      endTime: moment(startOfDay + defaultEndTime * 60 * 1000)
                    });
                  }
                  this.setState({isLoop});
                }}
              />

              <div
                className={this.state.isLoop ? 'meeting-loop-type' : 're-hidden'}
              >
                <Select
                  disabled={this.state.viewOnly || svcApplied}
                  value={this.state.loopType}
                  defaultValue="day"
                  onChange={value => {
                    this.setState({loopType: value});
                  }}
                >
                  <Option value="day">
                    {this.props.intl.formatMessage({id: 're_day'})}
                  </Option>
                  <Option value="week">
                    {this.props.intl.formatMessage({id: 're_week'})}
                  </Option>
                </Select>
              </div>
            </label>
          </div>}
          <div
            className={`loop-reserve ${
              this.state.isLoop ? 'meeting-loop-area' : 're-hidden'
              }`}
          >
            <div className="meeting-time">
            <span className="title">
              <FormattedMessage id="re_date_time"/>
            </span>
              <div className="time-cont">
                <ul>
                  <li className="loop-start-list">
                  <span className="text meeting-div-new-span">
                    <FormattedMessage id="re_start"/>
                  </span>
                    <Select
                      disabled={this.state.viewOnly || svcApplied}
                      value={String(this.state.defaultStartTime)}
                      dropdownMatchSelectWidth={false}
                      dropdownClassName="dropdown-start-time"
                      onChange={value => {
                        if (1440 - Number(value) < this.state.loopInterval) {
                          this.setState({
                            defaultStartTime: Number(value),
                            defaultEndTime:
                              Number(value) + (1440 - Number(value)),
                            loopInterval: 1440 - Number(value),
                            loopEndLists: this.getLoopEndTime(
                              this.timeList,
                              Number(value) + (1440 - Number(value)),
                              1440 - Number(value),
                              value
                            )
                          });
                          let b = moment(this.state.defaultStartTime).startOf(
                            'day'
                          );
                          this.refreshMeetingTree({
                            loopBeginTime: b.minutes(Number(value))
                          });
                        } else {
                          this.setState({
                            defaultStartTime: Number(value),
                            defaultEndTime:
                              Number(value) + Number(this.state.loopInterval),
                            loopEndLists: this.getLoopEndTime(
                              this.timeList,
                              Number(value) + Number(this.state.loopInterval),
                              this.state.loopInterval,
                              value
                            )
                          });
                          let b = moment(this.state.defaultStartTime).startOf(
                            'day'
                          );
                          this.refreshMeetingTree({
                            loopBeginTime: b.minutes(Number(value))
                          });
                        }
                      }}
                    >
                      {this.state.loopStartLists}
                    </Select>
                  </li>
                  <li className="loop-end-list">
                  <span className="text meeting-div-new-span">
                    <FormattedMessage id="re_end"/>
                  </span>
                    <Select
                      disabled={this.state.viewOnly || svcApplied}
                      value={String(this.state.defaultEndTime)}
                      dropdownMatchSelectWidth={false}
                      dropdownClassName="dropdown-end-time"
                      onChange={value => {
                        this.setState({
                          loopInterval:
                            Number(value) - Number(this.state.defaultStartTime),
                          defaultEndTime: Number(value)
                        });
                        let b = moment(this.state.defaultStartTime).startOf(
                          'day'
                        );
                        this.refreshMeetingTree({
                          loopEndTime: b.minutes(Number(value))
                        });
                      }}
                    >
                      {this.state.loopEndLists}
                    </Select>
                  </li>
                </ul>
              </div>
            </div>
            <div className="regular">
            <span className="title">
              <FormattedMessage id="regular_pattern"/>
            </span>
              {loopDiv}
            </div>
            <div className="loop-range">
              <div className="title">
                <FormattedMessage id="repeat_range"/>
              </div>
              <div className="type-left">
              <span className="text">
                <FormattedMessage id="re_start"/>
              </span>
                <DatePicker
                  disabled={this.state.viewOnly || svcApplied}
                  allowClear={false}
                  value={this.state.beginTime}
                  format="YYYY-MM-DD"
                  showToday={false}
                  disabledDate={this.disabledBeginDate}
                  onChange={value => {
                    this.setState({beginTime: value});
                  }}
                />
              </div>
              <div className="type-right">
              <span className="text" style={{marginRight: 8}}>
                <FormattedMessage id="re_repeat"/>
              </span>
                <InputNumber
                  disabled={this.state.viewOnly || svcApplied}
                  value={this.state._range || 1}
                  min={1}
                  ref={ref => {
                    this.rangeInput = ref;
                  }}
                  onChange={value => {
                    this.range = value;
                    this.setState({_range: value});
                  }}
                />
                <span className="text">
                <FormattedMessage id="cycle_times"/>
              </span>
              </div>
            </div>
          </div>


          <div className="append">
          </div>
          <Modal
            title={<div className="meeting_fee_title">{intl.formatMessage({id: 'meeting_fee_notice'})}</div>}
            maskClosable={false}
            visible={this.state.showPriceModal}
            onOk={() => {
              let meeting = this.state.tempMeeting;
              let reType = this.state.reType;
              meeting.skipPrice = 1;
              this.setState({showPriceModal: false});
              this.onBooking(meeting, reType);
            }}
            onCancel={() => {
              this.setState({showPriceModal: false})
            }}
            okText={intl.formatMessage({id: 'continue_book'})}
            cancelText={intl.formatMessage({id: 'cancel_book'})}
            wrapClassName="meeting_fee_wrap"
            width={480}
          >
            {this.getFeeDiv()}
          </Modal>
          <div className="append">
            {this.getButtonDiv({needAudit, hasSign, hasVideoRoom})}
          </div>
        </div>
      </div>
    );
  }

  getAppendixDiv = needAudit => {
    const {userInfo = {}} = this.props;
    if (needAudit && userInfo.roleKey === ROLES_KEY.reserve_helper) {
      const props = {
        action: `/storage/file/savefile?lang=zh_CN&token=${sessionStorage.getItem(
          'token'
        )}&fromType=${CLIENT_ID}`,
        showUploadList: this.state.viewOnly ? {showRemoveIcon: false} : true,
        fileList: this.state.fileList,
        disabled: this.state.viewOnly,
        name: 'fileUpload',
        beforeUpload: file => {
          if (file.size > 10 * 1024 * 1024) {
            Modal.error({content: '附件最大不能超过10M!'});
            return false;
          }
        },
        onChange: ({fileList, file}) => {
          if (file.size > 10 * 1024 * 1024) {
            return false;
          }
          if (file.status === 'done' && file.response) {
            this.setState({
              appendix: file.response.list[0].fileUrl,
              appendixName: file.name
            });
          }
          this.setState({fileList: [fileList[fileList.length - 1]]});
        },
        onRemove: () => {
          this.setState({fileList: [], appendix: '', appendixName: ''});
        }
      };
      return (
        <div className="append">
          <div className="detail-flex-div">
            <p className="name">
              <FormattedMessage id="meeting_file"/>：
            </p>
            <div>
              <Upload {...props}>
                <Button className="appendix-btn" disabled={this.state.viewOnly}>
                  <Icon type="upload"/>
                  <FormattedMessage id="re_upload"/>
                </Button>
              </Upload>
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  };

  /**
   * @param needAudit 当前选择的会议室是否需要审批
   * @param hasSign
   * @param hasVideoRoom
   * */
  getButtonDiv = ({needAudit, hasSign, hasVideoRoom}) => {
    if (this.state.viewOnly) return null;
    const {intl} = this.props;
    const {status, audit} = this.props.meeting;
    let btn1Msg = '',
      btn3Msg;
    if (needAudit) {
      //当前选择的会议室需要审批
      if (this.state.meetingId && this.state.meetingId !== 0) {
        //编辑会议
        if (audit === MEETING_AUDIT.yes) {
          //会议本来也是需要审批的
          if (status === MEETING_STATUS.pending) {
            //会议审批已经通过
            btn3Msg = intl.formatMessage({id: 'reservation_send_notice'});
          } else if (status === MEETING_STATUS.reject) {
            //会议审批未通过
            btn1Msg = intl.formatMessage({id: 'reservation_apply'});
          }
        } else {
          //会议本来不需要审批，现在改成了要审批
          btn1Msg = intl.formatMessage({id: 'reservation_apply'});
        }
      } else {
        //预约会议
        btn1Msg = intl.formatMessage({id: 'reservation_apply'});
      }
    } else {
      //当前选择的会议室不需要审批
      btn1Msg =
        this.state.meetingId && this.state.meetingId !== 0
          ? intl.formatMessage({id: 'reservation_save'})
          : intl.formatMessage({id: 'main_meeting_book'});
    }
    return (
      <div className="button-div">
        {btn1Msg && (
          <a
            disabled={!this.props.bookAble}
            className="btn_1"
            onClick={this.bookMeeting.bind(this, {
              hasSign,
              needAudit,
              hasVideoRoom
            })}
          >
            {btn1Msg}
          </a>
        )}
        {btn3Msg && (
          <a
            disabled={!this.props.bookAble}
            className="btn_2"
            onClick={this.sendMeetingNotice}
          >
            {btn3Msg}
          </a>
        )}
      </div>
    );
  };

  getLoopDiv = svcApplied => {
    const weeks =
      this.props.intl.formatMessage({id: 'locale'}) === ENGLISH
        ? WEEKDAY.ENGLISH
        : WEEKDAY.CHINESE;
    const dayOptions = [
      {
        label: (
          <span
            style={{
              width: '40px',
              display: 'inline-block',
              verticalAlign: 'middle'
            }}
          >
        {weeks[0]}
        </span>
        ),
        value: '1'
      },
      {
        label: (
          <span
            style={{
              width: '40px',
              display: 'inline-block',
              verticalAlign: 'middle'
            }}
          >
        {weeks[1]}
        </span>
        ),
        value: '2'
      },
      {
        label: (
          <span
            style={{
              width: '40px',
              display: 'inline-block',
              verticalAlign: 'middle'
            }}
          >
        {weeks[2]}
        </span>
        ),
        value: '3'
      },
      {
        label: (
          <span
            style={{
              width: '40px',
              display: 'inline-block',
              verticalAlign: 'middle'
            }}
          >
        {weeks[3]}
        </span>
        ),
        value: '4'
      },
      {
        label: (
          <span
            style={{
              width: '40px',
              display: 'inline-block',
              verticalAlign: 'middle'
            }}
          >
        {weeks[4]}
        </span>
        ),
        value: '5'
      },
      {
        label: (
          <span
            style={{
              width: '40px',
              display: 'inline-block',
              verticalAlign: 'middle'
            }}
          >
        {weeks[5]}
        </span>
        ),
        value: '6'
      },
      {
        label: (
          <span
            style={{
              width: '40px',
              display: 'inline-block',
              verticalAlign: 'middle'
            }}
          >
        {weeks[6]}
        </span>
        ),
        value: '7'
      }
    ];
    let loopDiv = null;
    switch (this.state.loopType) {
      case 'day':
        loopDiv = (
          <div className="day">
            <RadioGroup
              disabled={this.state.viewOnly || svcApplied}
              value={this.state.loopEdit.day.def}
              onChange={e => {
                this.dayRule = e.target.value;
                let {day} = this.state.loopEdit;
                day.def = this.dayRule;
                this.setState({
                  loopEdit: {
                    day: day,
                    week: this.state.loopEdit.week
                  }
                });
              }}
            >
              <Radio key="a" value={0}>
                <div className="loop-data">
                  <FormattedMessage id="re_every"/>
                  <InputNumber
                    style={{margin: '0 8px'}}
                    precision={0}
                    disabled={this.state.viewOnly || svcApplied}
                    value={this.state.loopEdit.day.value}
                    ref={ref => {
                      this.loopDay = ref;
                    }}
                    onChange={value => {
                      let {day} = this.state.loopEdit;
                      day.value = value;
                      this.loopDayValue = value;
                      this.setState({
                        loopEdit: {
                          day: day,
                          week: this.state.loopEdit.week
                        }
                      });
                    }}
                    min={1}
                  />
                  <FormattedMessage id="re_day"/>
                </div>
              </Radio>
              <Radio key="b" value={1}>
                <div className="working-day">
                  <FormattedMessage id="re_work_day"/>
                </div>
              </Radio>
            </RadioGroup>
          </div>
        );
        break;
      case 'week':
        loopDiv = (
          <div className="week">
            <div className="type">
              <Radio
                disabled={this.state.viewOnly || svcApplied}
                defaultChecked
              >
                <FormattedMessage id="re_every"/>
                <FormattedMessage id="re_week_thw"/>：
              </Radio>
            </div>
            <div className="type">
              <CheckboxGroup
                disabled={this.state.viewOnly || svcApplied}
                options={dayOptions}
                value={this.state.loopEdit.week.weeks}
                onChange={value => {
                  this.weekValue = value.sort().join(';');
                  let {week} = this.state.loopEdit;
                  week.weeks = value;
                  this.setState({
                    loopEdit: {
                      day: this.state.loopEdit.day,
                      week: week
                    }
                  });
                }}
              />
            </div>
          </div>
        );
        break;
    }
    return loopDiv;
  };

  /**
   * 检查预订当前选中的会议室是否需要审批
   * @return boolean true:需要审批，false:不需要审批
   * */
  checkNeedAudit = () => {
    const roomIdArr = this.state.moreMeeting || [];
    if (!roomIdArr || roomIdArr.length === 0) return false;
    const {allRoomsList = {}, userInfo} = this.props;
    const {list: rooms = []} = allRoomsList || {};
    for (let roomId of roomIdArr) {
      roomId = roomId.replace(/common-/g, '');
      for (let room of rooms) {
        if (roomId === String(room.id)) {
          if (room.audit === ROOM_NEED_AUDIT.yes) {
            //会议室本身需要审批
            return true;
          }
          break;
        }
      }
    }
    return false;
  };

  /**
   * 检查会议服务的审批状态，如果会议服务在审批中、已审批通过或不审批的状态，则不允许修改会议的基本信息，只能修改参会人
   * */
  checkSvcApplied = () => {
    let svcApplied = false;
    const meetingId = getUrlParam('meetingId');
    if (meetingId) {
      //编辑会议
      const {meeting = {}} = this.props;
      const {svcAuditState} = meeting;
      if (
        svcAuditState === SVC_STATE.audit ||
        svcAuditState === SVC_STATE.agree ||
        svcAuditState === SVC_STATE.noAudit
      ) {
        svcApplied = true;
      }
      return svcApplied;
    } else {
      return false;
    }
  };

  onMeetingNameChange = e => {
    this.setState({meetingName: e.target.value});
  };

  bookMeeting = ({hasSign, needAudit, hasVideoRoom}) => {
    const {holidays, meetingPolicy} = this.props;
    if (!this.props.bookAble) {
      return;
    } else {
      this.props.dispatch({
        type: 'meetingInfo/updateBookAble',
        payload: {bookAble: false}
      });
    }

    const reType = getUrlParam('reType') || 0; //循环会议编辑整个系列会议(1:是，0:否)
    const reserveMeetingId = getUrlParam('reserveMeetingId') || 0;
    let meeting = {};
    meeting.reserveMeetingId = reserveMeetingId;
    meeting.meetingId = getUrlParam('meetingId') || this.state.meetingId;
    meeting.reserveType = 0;
    meeting.isSendSms = this.state.isSendSms;
    meeting.isSendEmail = this.state.isSendEmail;
    meeting.isSendVsk = this.state.isSendVsk;
    meeting.isSendWechat = this.state.isSendWechat;
    meeting.isSendDingTalk = this.state.isSendDingTalk;
    meeting.meetingType = this.state.meetingType;
    meeting.openVideo = hasVideoRoom ? this.state.openVideo : 1;
    meeting.needToSign = hasSign ? this.state.needToSign : 1;
    meeting.signTime = this.state.signTime;
    meeting.appendix = this.state.appendix || '';
    meeting.appendixName = this.state.appendixName || '';
    meeting.isNeedConfirm = 1; //需要回执
    meeting.audit = needAudit ? MEETING_AUDIT.yes : MEETING_AUDIT.no;
    meeting.name = Base64.encode(
      this.state.meetingName ? this.state.meetingName : ''
    );
    meeting.remark = Base64.encode(
      this.state.remark ? this.state.remark : ''
    );
    if (this.state.holder.length > 0) {
      for (let item of this.state.holder) {
        //这里永远只有一个值
        meeting.holdId = item.userId;
        meeting.holder = item.userName;
      }
    } else {
      meeting.holdId = Meeting.holdId;
      meeting.holder = Meeting.holder;
    }
    meeting.roomIds = '';
    if (this.state.moreMeeting.length > 0) {
      let selectIds = this.state.moreMeeting;
      let finalKeys = [];
      selectIds.forEach(id => {
        if (String(id).indexOf('common-') > -1) {
          finalKeys.push(String(id).split('-')[1]);
        } else {
          finalKeys.push(String(id));
        }
      });
      meeting.roomIds += finalKeys.join(';');
    }

    if (meeting.name == '') {
      Modal.warning({
        content: this.props.intl.formatMessage({id: 'meeting_name_not_null'}),
        okText: this.props.intl.formatMessage({id: 'modal_manage_btn_ok'})
      });
      this.props.dispatch({
        type: 'meetingInfo/updateBookAble',
        payload: {bookAble: true}
      });
      return;
    }

    if (this.state.meetingName.length < 3) {
      Modal.warning({
        content: this.props.intl.formatMessage({
          id: 'meeting_name_less_than_3'
        }),
        okText: this.props.intl.formatMessage({id: 'modal_manage_btn_ok'})
      });
      this.props.dispatch({
        type: 'meetingInfo/updateBookAble',
        payload: {bookAble: true}
      });
      return;
    }
    if (meeting.roomIds == '') {
      Modal.warning({
        content: this.props.intl.formatMessage({id: 'room_no_null'}),
        okText: this.props.intl.formatMessage({id: 'modal_manage_btn_ok'})
      });
      this.props.dispatch({
        type: 'meetingInfo/updateBookAble',
        payload: {bookAble: true}
      });
      return;
    }
    if (meeting.holdId == '') {
      Modal.warning({
        content: this.props.intl.formatMessage({id: 'holder_no_null'}),
        okText: this.props.intl.formatMessage({id: 'modal_manage_btn_ok'})
      });
      this.props.dispatch({
        type: 'meetingInfo/updateBookAble',
        payload: {bookAble: true}
      });
      return;
    }
    if (0 == meeting.needToSign && !meeting.signTime) {
      Modal.warning({
        content: this.props.intl.formatMessage({id: 'sign_time_no_null'}),
        okText: this.props.intl.formatMessage({id: 'modal_manage_btn_ok'})
      });
      this.props.dispatch({
        type: 'meetingInfo/updateBookAble',
        payload: {bookAble: true}
      });
      return;
    }
    if (!this.state.isLoop && this.state.crossDay == 1) {//如果长期会议 校验
      let days = meetingPolicy.crossDaysMeetingMinDay;
      let momentStart = moment(this.state.beginTime);
      let momentEnd = moment(this.state.endTime);
      let limit = moment(momentStart.valueOf() - 1000 * 60).add(days, 'days');
      if (momentEnd.diff(limit) < 0) {
        Modal.warning({
          content: this.props.intl.formatMessage({id: 'cross_days_meeting_days_limit'}, {num: days}),
          okText: this.props.intl.formatMessage({id: 'modal_manage_btn_ok'})
        });
        this.props.dispatch({
          type: 'meetingInfo/updateBookAble',
          payload: {bookAble: true}
        });
        return;
      }
    }
    let members = [],
      fulIds = [],
      invites = [];
    this.state.attends.map(item => {
      if (item.selectType == 0) {
        members.push(item.userId);
      } else {
        if (item.invite) {
          invites.push(1);
        } else {
          invites.push(0);
        }
        fulIds.push(item.userId);
      }
    });
    meeting.members = members.join(';');
    meeting.fulds = fulIds.join(';');
    meeting.isNeedConfirm = Meeting.isNeedConfirm;
    meeting.skipConflict = this.state.skipConflict;
    meeting.ignoreExtends = this.state.ignoreExtends;
    //循环会议
    if (this.state.isLoop) {
      switch (this.state.loopType) {
        case 'day':
          meeting.type = 1;
          meeting.rrule = this.dayRule || this.state.loopEdit.day.def || 0;
          meeting.exrule =
            (meeting.rrule == 1
              ? ''
              : this.loopDayValue ||
              this.state.loopEdit.day.value ||
              this.loopDay.props.defaultValue) || ''; //工作日的时候可以什么都不传。
          break;
        case 'week':
          meeting.type = 2;
          meeting.rrule =
            this.weekRuleValue ||
            this.state.loopEdit.week.def ||
            this.weekRule.props.defaultValue ||
            0;
          meeting.exrule =
            this.weekValue || this.state.loopEdit.week.weeks.join(';') || '';
          break;
        default:
          meeting.type = 0;
      }
      meeting.lastTime = this.state.loopInterval; //持续时间
      meeting.range =
        this.range ||
        (this.props.meeting.range && this.props.meeting.range.indexOf('-') > 0
          ? new Date(
            Date.parse(this.props.meeting.range.replace(/-/g, '/'))
          ).getTime()
          : this.props.meeting.range) ||
        10; //重复范围
      //开始时间
      meeting.startTime =
        Date.parse(
          formatTimeStampToDate(
            moment(this.state.beginTime)
              .startOf('day')
              .valueOf(),
            'YYYY/MM/DD'
          )
        ) +
        this.state.defaultStartTime * 60000;
      meeting.endTime = this.state.beginTime
        .startOf('day')
        .add(this.state.defaultEndTime, 'minutes')
        .valueOf();
    } else {
      //非循环会议
      meeting.type = Meeting.type; // 会议类型(0: 普通会议|1.周期会议[按天]|2: 周期会议[按周]|3: 周期会议[按月]|4: 周期会议[按年])
      meeting.startTime =
        (this.state.beginTime && this.state.beginTime.valueOf()) || 0;
      if (
        meeting.startTime &&
        meeting.startTime != this.props.meeting.startTime
      ) {
        meeting.otherStartTime = this.props.meeting.startTime;
      }
      meeting.endTime =
        (this.state.endTime && this.state.endTime.valueOf()) || 0;
      meeting.lastTime = Math.floor(
        (meeting.endTime - meeting.startTime) / 60000
      ); //转化时间差，3.2 取 4

      const dateStr = moment(meeting.startTime).format('YYYY-MM-DD');
      if (holidays && holidays.some(x => x.dayTimeFormat == dateStr)) {
        Modal.warning({
          content: `"${dateStr}"已被设置为节假日，请重新选择日期！`,
          okText: this.props.intl.formatMessage({id: 'modal_manage_btn_ok'})
        });
        this.props.dispatch({
          type: 'meetingInfo/updateBookAble',
          payload: {bookAble: true}
        });
        return false;
      }
    }
    if (meeting.id > 0 && 0 == reType) {
      //处理循环会议编辑单个会议
      meeting.type = Meeting.type;
    }
    // 计算会议室人数限制，提示参会人数异常
    let minNumber = 0,
      maxNumber = 0;
    const roomIds = meeting.roomIds.split(';');
    this.props.allRoomsList.list &&
    this.props.allRoomsList.list.map(item => {
      if (roomIds.indexOf(String(item.id)) > -1) {
        minNumber += item.minNumber;
        maxNumber += item.maxNumber;
      }
    });
    let currentDate = new Date();
    if (currentDate.getTime() > meeting.startTime && !this.state.startNow) {
      Modal.warning({
        content: this.props.intl.formatMessage({
          id: 'start_time_no_available'
        }),
        okText: this.props.intl.formatMessage({
          id: 'modal_manage_btn_ok'
        })
      });
      this.props.dispatch({
        type: 'meetingInfo/updateBookAble',
        payload: {bookAble: true}
      });
      return;
    }
    if (this.state.cmmaMeeting === 1) {
      // 视频会议相关参数
      meeting.cmmaMeeting = this.state.cmmaMeeting;
      meeting.joinPwd = this.state.joinPwd;
      meeting.startAuto = this.state.startAuto;
      meeting.autoReconnect = this.state.autoReconnect;
    }
    meeting.startNow = this.state.startNow;
    meeting.duration = this.state.duration;

    //会议预约访客加的接口
    meeting.visitType = 0;
    meeting.outerJson = '';

    if (this.props.inviteFlag == 1) {
      if (invites.indexOf(1) > -1) {
        meeting.visitType = 1;
      }
      let outerJson = [];
      this.state.attends.map(item => {
        if (item.invite) {
          let outer = {};
          outer.fuId = item.userId;
          outer.userName = Base64.encode(item.userName ? item.userName : '');
          item.mobile = item.mobile || '';
          if (item.mobile.indexOf('+86') > -1) {
            //+86
            outer.mobile = item.mobile.substring(3);
          }
          if (item.mobile.indexOf('+852') > -1) {
            //+852
            outer.mobile = item.mobile.substring(4);
          }
          if (item.mobile.indexOf('+86') == -1 && item.mobile.indexOf('+852') == -1) {
            //不含有区号
            outer.mobile = item.mobile;
          }
          outer.email = item.email;
          outer.telAreaCode = item.telAreaCode || '';
          outerJson.push(outer);
        }
      });
      meeting.outerJson = outerJson;
    }

    //周期会议不能预约访客
    //1.周期会议[按天]|2: 周期会议[按周]|3: 周期会议[按月]|4: 周期会议[按年])
    if (meeting.type == 2 || meeting.type == 1 || meeting.type == 3 || meeting.type == 4) {
      if (meeting.visitType == 1) {//说明有外部参会人
        Modal.warning({content: '周期会议不能预约访客!', okText: '确认'});
        this.props.dispatch({type: 'meetingInfo/updateBookAble', payload: {bookAble: true}});
        return;
      }
    }
    if (
      this.state.attends.length > Number(maxNumber - 1) ||
      this.state.attends.length < Number(minNumber - 1)
    ) {
      Modal.confirm({
        content:
          this.state.attends.length > Number(maxNumber - 1)
            ? this.props.intl.formatMessage({id: 'book_meeting_people_more'})
            : this.props.intl.formatMessage({id: 'book_meeting_people_less'}),
        onOk: () => {
          this.onBooking(meeting, reType);
        },
        onCancel: () => {
          this.props.dispatch({
            type: 'meetingInfo/updateBookAble',
            payload: {bookAble: true}
          });
        }
      });
    } else {
      this.onBooking(meeting, reType);
    }
  };

  onBooking = (meeting, reType) => {
    meeting.skipPrice = meeting.skipPrice == 1 ? 1 : 0;
    const promise = new Promise((resolve, reject) => {
      this.props.dispatch({
        type: 'meeting/bookingMeeting',
        meeting: meeting,
        isReload: true,
        reType,
        resolve,
        reject,
      });
    });
    promise.then(
      () => {
        const {meeting} = this.props;
        const {audit, meetingCtrl} = meeting;
        let callNumber = this.state.callNumber;
        if (meeting.cmmaMeeting === 1 && meetingCtrl) {
          callNumber = meetingCtrl.callNumber;
        }
        this.setState({
          viewOnly: this.state.viewOnly || audit === MEETING_AUDIT.yes,
          showPriceModal: false
        });
      },
      (result) => {
        const {msg, data, meeting, reType} = result;
        if (msg == 'noticePrice') {
          this.setState({
            showPriceModal: true,
            priceInfo: {...this.state.priceInfo, ...data},
            tempMeeting: meeting,
            tempReType: reType
          });
          return false;
        }
        if (data && data.type > -1) {
          if (data.type == 4) {
            const {holidays = [], maintains = []} = data;
            const tipContent = [];
            if (holidays && holidays.length > 0) {
              const hArray = [];
              holidays.map((holiday, index) => {
                hArray.push(<div key={index} style={{flex: "0 0 33.3%"}}>{holiday}</div>)
              });
              tipContent.push(<div style={{display: "flex", alignItems: "center"}}>
        <span style={{
          flex: "0 0 73px",
          textAlign: 'right',
          paddingRight: '5px'
        }}>{this.props.intl.formatMessage({id: 'meeting_tips_holiday'}) + " : "}</span>
                <span style={{display: "flex", flexWrap: "wrap", flex: 1}}>{hArray}</span>
              </div>);
            }
            if (maintains && maintains.length > 0) {
              const mArray = [];
              maintains.map((maintain, index) => {
                mArray.push(<div key={index} style={{padding: "2px 0"}}>{maintain}</div>)
              });
              tipContent.push(<div style={{display: "flex", alignItems: "center", marginTop: '10px'}}>
        <span style={{
          flex: "0 0 73px",
          textAlign: 'right',
          paddingRight: '5px'
        }}>{this.props.intl.formatMessage({id: 'meeting_tips_room_maintain'}) + " : "}</span>
                <span style={{display: "flex", flexWrap: "wrap", flex: 1}}>{mArray}</span>
              </div>);
            }
            const content = (<div style={{maxHeight: '500px', overflowY: 'auto'}}>{tipContent}</div>);
            Modal.confirm({
              title: msg,
              content: content,
              className: 'custom-modal',
              okText: this.props.intl.formatMessage({id: 'meeting_save_tips_yes'}),
              cancelText: this.props.intl.formatMessage({id: 'meeting_save_tips_no'}),
              onOk: () => {
                meeting.ignoreExtends = 0;
                this.onBooking(meeting, reType);
              }
            });
          } else {
            const array = [];
            const mapKeys = Object.keys(data.conMap);
            mapKeys.sort((x, y) => {
              if (x < y) {
                return -1;
              } else if (x > y) {
                return 1;
              } else {
                return 0;
              }
            });
            mapKeys.forEach((key, i) => {
              let timeArray = key.split(";");
              let timeRange = timeArray[0] + "~" + moment(timeArray[1]).format("HH:mm");
              let verifyInfo = data.conMap[key];
              let reason = this.props.intl.formatMessage({id: 'meeting_save_tips_reason_' + verifyInfo.type.split(";")[0]});
              array.push(<div key={i} className="meeting-detail-border">
                <div
                  style={{lineHeight: '22px'}}>{this.props.intl.formatMessage({id: 'meeting_save_tips_time'}) + " : " + timeRange}</div>
                <div style={{lineHeight: '22px'}}>
                  {this.props.intl.formatMessage({id: 'meeting_save_tips_reason'}) + " : " + reason}
                  <span style={{color: "#b2b2b2"}}>
        {" (" + this.props.intl.formatMessage({id: 'meeting_save_tips_holder'}) + " : " + verifyInfo.holder + " " + this.props.intl.formatMessage({id: 'meeting_save_tips_subject'}) + " : " + verifyInfo.name + ")"}
        </span>
                </div>
              </div>)
            });
            const content = (
              <div style={{maxHeight: '500px', overflowY: 'auto', paddingLeft: '35px'}}>{array}</div>
            );
            if (data.available > 0) {
              Modal.confirm({
                title: this.props.intl.formatMessage({id: 'meeting_save_tips_modal_title1'}),
                content: content,
                className: 'custom-modal',
                okText: this.props.intl.formatMessage({id: 'meeting_save_tips_yes'}),
                cancelText: this.props.intl.formatMessage({id: 'meeting_save_tips_no'}),
                onOk: () => {
                  meeting.skipConflict = 1;
                  this.onBooking(meeting, reType);
                }
              });
            } else {
              Modal.info({
                className: 'custom-modal',
                title: this.props.intl.formatMessage({id: 'meeting_save_tips_modal_title2'}),
                content: content
              });
            }
          }
        } else {
          Modal.warning({
            title: this.props.intl.formatMessage({id: 'index_meeting_save_failed'}),
            content: msg
          });
        }
      }
    );
  };

  sendMeetingNotice = () => {
    const meetingId = getUrlParam('meetingId') || this.state.meetingId;
    this.props.dispatch({
      type: 'meeting/sendMeetingNotice',
      meetingId: meetingId
    });
  };

  getFeeDiv = () => {
    const {intl, meetingPolicy: {showMeetingSvc = 0, billingSwitch}} = this.props;
    const {priceInfo} = this.state;
    if (priceInfo == null) {
      return null;
    }
    let showMeetingTime = "";
    const {startTime, endTime, duringTime = 0, feeTime = 0, roomPrice = 0, svcPrice = 0, total = 0, rooms = []} = priceInfo;
    let startTimeMoment = moment(startTime);
    let endTimeMoment = moment(endTime);
    if (startTimeMoment.format(TIME_FORMAT.date) == endTimeMoment.format(TIME_FORMAT.date)) {
      showMeetingTime = `${startTimeMoment.format(TIME_FORMAT.date)} ${startTimeMoment.format(TIME_FORMAT.time)} ~ ${endTimeMoment.format(TIME_FORMAT.time)}`;
    } else {
      showMeetingTime = `${startTimeMoment.format(TIME_FORMAT.date)} ${startTimeMoment.format(TIME_FORMAT.time)} ~ ${endTimeMoment.format(TIME_FORMAT.date)} ${endTimeMoment.format(TIME_FORMAT.time)}`;
    }
    console.log("priceInfo", priceInfo);
    return <div className="fee_div">
      {billingSwitch === 1 && <div className="fee_row">
        <div className="left">{intl.formatMessage({id: 'meeting_room_single_price'})}</div>
        <div className="right">
          {rooms.map(r => {
            return <p>
              <span>{intl.locale === 'en_US' ? r.nameEn : r.name}&nbsp;</span><span>(￥{r.rates ? parseFloat(r.rates).toFixed() : '0'} / {intl.formatMessage({id: 'room_fee_unit_hour'})})</span>
            </p>;
          })}
        </div>
      </div>}
      {billingSwitch === 1 && <div className="fee_row">
        <div className="left">{intl.formatMessage({id: 'room_fee_book_time'})}</div>
        <div className="right">{showMeetingTime}</div>
      </div>}
      {billingSwitch === 1 && <div className="fee_row">
        <div className="left">{intl.formatMessage({id: 'room_fee_during_time'})}</div>
        <div className="right">{feeTime} {intl.formatMessage({id: 'room_fee_unit_minute'})}</div>
      </div>}
      {billingSwitch === 1 && <div className="fee_row">
        <div className="left">{intl.formatMessage({id: 'room_fee_total'})}</div>
        <div style={{color: "red"}} className="right">￥{parseFloat(roomPrice).toFixed(2)}</div>
      </div>}
      {this.state.hasSaveSvc == 1 && showMeetingSvc == 1 && <div className="fee_row">
        <div className="left">{intl.formatMessage({id: 'meeting_svc_fee_total'})}</div>
        <div style={{color: "red"}} className="right">￥{parseFloat(svcPrice).toFixed(2)}</div>
      </div>}
      <div className="fee_row">
        <div className="left">{intl.formatMessage({id: 'meeting_fee_total'})}</div>
        <div style={{color: "red"}} className="right">￥{parseFloat(total).toFixed(2)}</div>
      </div>
    </div>;
  }
}

const mapStateToProps = state => {
  return {
    userInfo: state.login.userInfo,
    holidays: state.meeting.holidays,
    externalList: state.meeting.externalData,
    meetingTree: state.meeting.meetingTreeData,
    userByDept: state.meeting.userByDept,
    allDeptData: state.meeting.allDeptData,
    userList: state.meeting.userListData,
    allRoomsList: state.meeting.allRoomList,
    meeting: state.meetingInfo.meeting,
    bookAble: state.meetingInfo.bookAble,
    meetingVideo: state.meetingInfo.meetingVideoData,
    noticeConfig: state.meetingInfo.noticeConfig,
    noticeKeys: state.meetingInfo.noticeKeys,
    meetingInfo: state.meetingInfo,
    meetingPolicy: state.account.meetingPolicy || {},
    inviteFlag: state.meetingInfo.inviteFlag
  };
};
export default connect(mapStateToProps)(MeetingDetail);



// WEBPACK FOOTER //
// ./src/components/meeting/MeetingDetail.js